import { api } from './api'

/**
 * LOT-GATING — client du module gating backend (essai gratuit).
 *
 * Tout est calculé SERVEUR (GET /api/gating/status) : le frontend n'additionne
 * jamais lui-même des compteurs d'appels ou d'e-mails — il affiche.
 */

export interface GatingQuota {
  used: number
  /** null ⇔ illimité (tenant exempt ou abonné). */
  max: number | null
}

export interface GatingStatus {
  /** true ⇔ tenant en essai gratuit (limites actives). */
  trial: boolean
  calls: GatingQuota
  emails: GatingQuota
  smsBlocked: boolean
}

/** Codes STABLES portés par les 403 du guard backend (gating.constants.ts). */
export const TRIAL_QUOTA_EXCEEDED = 'TRIAL_QUOTA_EXCEEDED'
export const TRIAL_SMS_BLOCKED = 'TRIAL_SMS_BLOCKED'

export type TrialGatingCode =
  | typeof TRIAL_QUOTA_EXCEEDED
  | typeof TRIAL_SMS_BLOCKED

/**
 * Reconnaît un 403 du guard d'essai dans une erreur axios.
 * Renvoie le code stable, ou null si l'erreur vient d'ailleurs.
 */
export function trialGatingCode(error: unknown): TrialGatingCode | null {
  const code = (error as { response?: { data?: { code?: string } } })?.response
    ?.data?.code
  if (code === TRIAL_QUOTA_EXCEEDED || code === TRIAL_SMS_BLOCKED) return code
  return null
}

class GatingService {
  private static readonly BASE_PATH = '/gating'

  /** État d'essai du tenant courant — alimente le bandeau de l'AppShell. */
  static async getStatus(): Promise<GatingStatus> {
    const response = await api.get(`${this.BASE_PATH}/status`)
    return response.data
  }
}

export default GatingService
